import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import http from "../api/http";

const formatearFecha = (fecha) => {
  if (!fecha) return "-";
  return new Date(fecha).toLocaleDateString("es-AR");
};

const obtenerUnidadCantidad = (unidad) => String(unidad || "Unidad").trim() || "Unidad";

const formatearCantidad = (cantidad, unidad) =>
  `${Number(cantidad || 0).toLocaleString("es-AR")} ${obtenerUnidadCantidad(unidad)}`;

const formatearImporte = (importe) =>
  Number(importe || 0).toLocaleString("es-AR", {
    style: "currency",
    currency: "ARS",
  });

const etiquetasEstado = {
  ingresado: "Ingresado",
  en_produccion: "En produccion",
  finalizado: "Finalizado",
  anulado: "Anulado",
};

export default function TrackingMercaderia() {
  const { codigoTracking } = useParams();
  const [ingreso, setIngreso] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const obtenerTracking = async () => {
      try {
        setCargando(true);
        setError("");
        const { data } = await http.get(
          `/mercaderia/tracking/${encodeURIComponent(codigoTracking)}`,
        );
        setIngreso(data);
      } catch {
        setError("No se encontro informacion para este codigo de tracking.");
      } finally {
        setCargando(false);
      }
    };

    obtenerTracking();
  }, [codigoTracking]);

  if (cargando) {
    return (
      <div className="tracking-page">
        <div className="tracking-loading">Cargando tracking...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tracking-page">
        <div className="tracking-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="tracking-page">
      <div className="tracking-card">
        <div className="tracking-heading">
          <span>Especiar</span>
          <h1>Tracking de ingreso</h1>
        </div>

        <div className="tracking-code">{ingreso.codigoTracking}</div>

        <div className={`tracking-status estado-${ingreso.estado || "ingresado"}`}>
          Estado <strong>{etiquetasEstado[ingreso.estado] || "Ingresado"}</strong>
        </div>

        <div className="tracking-grid">
          <TrackingItem label="Tipo de ingreso" value={ingreso.tipoIngreso === "material" ? "Material de produccion" : "Producto"} />
          <TrackingItem label={ingreso.tipoIngreso === "material" ? "Material" : "Producto"} value={ingreso.producto} />
          <TrackingItem label="Proveedor" value={ingreso.proveedor} />
          <TrackingItem label="Fecha ingreso" value={formatearFecha(ingreso.fechaIngreso)} />
          <TrackingItem label="Lote / partida" value={ingreso.lotePartidaNro || "-"} />
          <TrackingItem
            label="Fecha elaboracion"
            value={formatearFecha(ingreso.fechaElaboracion)}
          />
          <TrackingItem
            label="Fecha vencimiento"
            value={formatearFecha(ingreso.fechaVencimiento)}
          />
          <TrackingItem
            label="Total ingresado"
            value={formatearCantidad(ingreso.cantidadRecibida, ingreso.unidadCantidad)}
          />
          <TrackingItem label="Costo total" value={formatearImporte(ingreso.costoTotal)} />
          <TrackingItem label="Transportista" value={ingreso.transportista} />
          <TrackingItem label="Ubicacion asignada" value={ingreso.ubicacionAsignada} />
        </div>

        <section className="tracking-section">
          <h2>Almacenamiento</h2>
          <div className="tracking-grid">
            <TrackingItem
              label="Cantidad"
              value={Number(ingreso.cantidadRecibida || 0).toLocaleString("es-AR")}
            />
            <TrackingItem label="Unidad de medida" value={obtenerUnidadCantidad(ingreso.unidadCantidad)} />
            <TrackingItem label="Ubicacion" value={ingreso.ubicacionAsignada} />
          </div>
        </section>
      </div>
    </div>
  );
}

function TrackingItem({ label, value }) {
  return (
    <div>
      <span>{label}</span>
      <strong>{value || "-"}</strong>
    </div>
  );
}
